import { useEffect, useState } from "react";

const useIsClientSide = () => {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    return isClient;
};

export { useIsClientSide };
